import React from 'react';
import useTranslatedText from '../../hooks/useTranslatedText';
import $window from '../../tools/window';
import SearchDefaultButtonGroup from './SearchDefaultButtonGroup';
import useHelpTopics from './hooks/useHelpTopics';

export default function HelpfulLinks() {
  const helpLinksData = useHelpTopics();
  const helpLinksLabel = useTranslatedText('helpLinks', { fallback: 'Helpful Links' });
  const handleHelpButtonClick = (event) => {
    const {
      target, type, key,
    } = event;
    if (type === 'click' || key === 'Enter') {
      if ($window.digitalData) {
        $window.digitalData.trigger('universal_click', {
          event_type: 'click',
          data_text: `Search-${target?.innerText}`,
          data_action: 'click',
        });
      }
    }
  };

  return (
    <SearchDefaultButtonGroup
      key="help topics"
      dataType="help topics"
      eventHandler={handleHelpButtonClick}
      groupId="help-topics-group"
      headingLabel={helpLinksLabel?.value}
      options={helpLinksData?.helpLinks?.map(
        (item) => ({
          key: item.id,
          title: item.title,
          url: item.url,
        }),
      )}
    />
  );
}
